// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-option',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormSelect {
  @Prop() optionText: string = 'Option Text';
  @Prop() optionValue: string = 'Option Text';

  render() {
    return <option value={this.optionValue}><slot /></option>;
  }
}